(function(){
    // Toggle dropdown on button click
    document.addEventListener('click', function(e){
        const button = e.target.closest('.hub-pages-links-dropdown-block .hub-dropdown-button');
        if (button) {
            e.preventDefault();
            const wrapper = button.closest('.hub-dropdown-wrapper');
            if (wrapper) {
                wrapper.classList.toggle('hub-dropdown-open');
            }
            return;
        }
        
        // Close dropdown when clicking outside
        if (!e.target.closest('.hub-pages-links-dropdown-block .hub-dropdown-wrapper')) {
            const allWrappers = document.querySelectorAll('.hub-pages-links-dropdown-block .hub-dropdown-wrapper');
            allWrappers.forEach(function(wrapper){
                wrapper.classList.remove('hub-dropdown-open');
            });
        }
    });

    // Toggle submenu
    document.addEventListener('click', function(e){
        const toggle = e.target.closest('.hub-pages-links-dropdown-block .hub-submenu-toggle');
        if (!toggle) return;
        e.preventDefault();
        e.stopPropagation();
        const submenu = toggle.parentElement && toggle.parentElement.querySelector(':scope > .hub-submenu');
        if (submenu) {
            const open = submenu.style.display === 'block';
            submenu.style.display = open ? 'none' : 'block';
            toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
            
            // Add/remove class to parent for hover state
            const parentItem = toggle.closest('.hub-has-submenu');
            if (parentItem) {
                if (open) {
                    parentItem.classList.remove('hub-submenu-open');
                } else {
                    parentItem.classList.add('hub-submenu-open');
                }
            }
        }
    });
    
    // Real-time filter
    document.addEventListener('input', function(e){
        if (!e.target.classList.contains('hub-dropdown-search-input')) return;
        const input = e.target;
        const query = input.value.toLowerCase().trim();
        const wrapper = input.closest('.hub-dropdown-wrapper');
        if (!wrapper) return;
        
        const allItems = wrapper.querySelectorAll('.hub-dropdown-list > li:not(.hub-dropdown-search-item)');
        
        // Filter items in real-time
        if (query === '') {
            // Show all items when search is empty
            allItems.forEach(function(item){
                item.style.display = '';
            });
        } else {
            allItems.forEach(function(item){
                const link = item.querySelector('a');
                const text = link ? link.textContent.toLowerCase() : '';
                const matches = text.includes(query);
                item.style.display = matches ? '' : 'none';
                
                // Also check children
                if (!matches) {
                    const childLinks = item.querySelectorAll('.hub-submenu a');
                    let hasMatchingChild = false;
                    childLinks.forEach(function(childLink){
                        if (childLink.textContent.toLowerCase().includes(query)) {
                            hasMatchingChild = true;
                        }
                    });
                    if (hasMatchingChild) {
                        item.style.display = '';
                        // Open submenu to show matching children
                        const submenu = item.querySelector('.hub-submenu');
                        if (submenu) {
                            submenu.style.display = 'block';
                        }
                    }
                }
            });
        }
    });
})();
